import React from 'react';

const Hero = () => {
    return (
        <section className="hero" id="home">
            <div className="container">
                {/* Hero content can be added here if needed */}
            </div>
        </section>
    );
};

export default Hero;